import { useEffect, useState } from "react";

import { useTopbarContext } from "shared/providers/Layout/hooks/useTopbarContext";
import { echo } from "shared/utils/echo";
import { useAuthContext } from "shared/utils/hooks/useAuthContext";
import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

import { captureException, captureMessage } from "@sentry/nextjs";

export const useUserNotificationsTrigger = () => {
  const { loggedUser } = useAuthContext();
  const {
    state: { tenancy },
  } = useGlobalContext();
  const { setHasNewNotifications, setAlreadyLoadedNewNotifications } =
    useTopbarContext();

  const [
    shouldStartUserNotificationsTrigger,
    setShouldStartUserNotificationsTrigger,
  ] = useState(false);

  const handleStartUserNotificationsTrigger = (): void =>
    setShouldStartUserNotificationsTrigger(true);

  useEffect(() => {
    if (!shouldStartUserNotificationsTrigger) return;
    const tenantUuid = tenancy?.uuid;

    try {
      echo
        ?.channel(`user-notifications.${tenantUuid}`)
        ?.listen(`User\\UserNotification`, (data: any) => {
          const userId = data?.userId;

          const shouldShowThatHaveNewNotifications = loggedUser?.id === userId;

          if (!shouldShowThatHaveNewNotifications) return;
          setHasNewNotifications(true);
          setAlreadyLoadedNewNotifications(false);
        });
    } catch (error) {
      console.log("Erro (useUserNotificationsTrigger): ", error);
      captureMessage("Error (useUserNotificationsTrigger)");
      captureException(error);

      setShouldStartUserNotificationsTrigger(false);
    }

    return () => {
      if (echo) echo.leaveChannel(`user-notifications.${tenantUuid}`);
      setHasNewNotifications(false);
    };
  }, [echo, shouldStartUserNotificationsTrigger]);

  return {
    handleStartUserNotificationsTrigger,
  };
};
